import React, { FC, ReactElement, ReactNode } from "react";
import { Modal } from "@skyportal/ui-kit";
import cn from "classnames";

import styles from "./BucketModalShell.module.css";

interface Props {
  children: ReactNode;
  controls: ReactElement;
  onClose: () => void;
  open: boolean;
  title: string;
  className?: string;
}

const BucketModalShell: FC<Props> = ({ children, controls, onClose, open, title, className }) => {
  return (
    <Modal
      className={cn(styles.modal, className)}
      open={open}
      onClose={onClose}
      onCloseBtnClick={onClose}
      title={title}
      size="small"
      controls={controls}
    >
      {children}
    </Modal>
  );
};

export default BucketModalShell;
